export enum ActionTypes {
 GET_PURCHASE = '[GET_PURCHASE] Get purchase',
 GET_PURCHASE_SUCCESS = '[GET_PURCHASE] Get purchase success',
 GET_PURCHASE_FAILURE = '[GET_PURCHASE] Get purchase failure',
}
